import { Toaster as Sonner } from "sonner";

function Toaster(props) {
  return <Sonner {...props} />;
}

export { Toaster };
